export const privateConsumptionDefaults = {
  byPersons: {
    1: 1800,
    2: 2800,
    3: 3800,
    4: 4800,
    5: 5800
  },
  evKwhByPersons: {
    1: 2000,
    2: 2500,
    3: 3000,
    4: 3500,
    5: 4000
  },
  heatPumpKwhByPersons: {
    1: 2500,
    2: 3500,
    3: 4500,
    4: 5500,
    5: 6500
  },
};

export const injectorYieldDefaults = {
  pvYieldPerKwpDefault: 950,
  bhkwFullLoadHoursDefault: 4500,
  windYieldFactorDefault: 1400,
  fuelCellRunHoursDefault: 6000
};

export const injectorTypes = [
  { value: "pv", label: "Photovoltaik (PV)" },
  { value: "bhkw", label: "Blockheizkraftwerk (BHKW)" },
  { value: "wind", label: "Windkraft" },
  { value: "fuel_cell", label: "Brennstoffzelle" },
  { value: "generator", label: "Generator" }
];

export const injectorStatusOptions = [
  { value: "existing", label: "Vorhanden" },
  { value: "planned", label: "Geplant" }
];

export const pvComplexityOptions = [
  { value: "standard", label: "Standard-PV-Anlage" },
  { value: "complex", label: "Gr\u00f6\u00dfere / komplexere PV-Anlage" }
];

export const generatorPhaseOptions = [
  { value: "single_phase", label: "1-phasig" },
  { value: "three_phase", label: "3-phasig" }
];

export const orientationOptions = [
  { value: "sued", label: "S\u00fcd" },
  { value: "sued_west", label: "S\u00fcd-West" },
  { value: "sued_ost", label: "S\u00fcd-Ost" },
  { value: "west", label: "West" },
  { value: "ost", label: "Ost" },
  { value: "nord_west", label: "Nord-West" },
  { value: "nord_ost", label: "Nord-Ost" },
  { value: "nord", label: "Nord" }
];

export const orientationFactors = {
  sued: 1.0,
  sued_west: 0.85,
  sued_ost: 0.85,
  west: 0.70,
  ost: 0.70,
  nord_west: 0.60,
  nord_ost: 0.60,
  nord: 0.55,
};
